const CommonTypography = (() => {

    class Core {

        constructor() {

            this.body = document.body;
            this.build();

        }


        build() {

            this.table();

        }


        table() {

            let parent = null,
                wrapper = null,
                tables = Array.from(this.body.querySelectorAll('.table'));


            if (tables.length > 0) {

                tables.forEach((variable) => {

                    parent = variable.parentNode;

                    wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper');
                    wrapper.appendChild(variable);
                    
                    parent.appendChild(wrapper);

                })

            }

        }

    }

    
    let active = null;


    const init = () => {

        active = new Core();
        return active;

    }


    return { init };

})()


window.CommonTypography = CommonTypography;


export { CommonTypography };